<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-textbox-control displayName="Name" description="Provide the program name." [control]="formGroup.controls.name" />
    <unity-textbox-control displayName="Code" description="Provide the program code (e.g. HAP)." [control]="formGroup.controls.code" />
    <ng-content submit-options>
      <unity-action-cancel-shared [disabled]="false" [action]="returnToDashboardAction" />
    </ng-content>
  </unity-card-new-shared>
</unity-page-container>
